import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import moment from "moment";

import partnersApi from "../../../apis/Partners.api";
import { toastAlert } from "../../AlertComponent";

const CommunityFavorite = ({ item, handleCommentMove, type, serviceType }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	useEffect(() => {
		if (reduxChannel?.user_id && item?.id) {
			getCommunityItemDetail();
		}
	}, [reduxChannel, item, cUser]);

	const favoriteLoading = useRef();

	const [itemNums, setItemNums] = useState({
		like: 0,
		comment: 0,
		view: 0,
	});
	const [isLike, setIsLike] = useState(false);

	const getCommunityItemDetail = async () => {
		favoriteLoading.current = false;
		const param = {
			influencerId: reduxChannel?.user_id,
			communityId: item?.id,
			userId: cUser?.id ?? 0,
		};
		const res = await partnersApi.readCommunityDetail(param);
		if (res.code === 200) {
			setIsLike(res.result.is_like);
			setItemNums({
				like: res.result.like_num,
				comment: res.result.comment_num,
				view: res.result.view_num,
			});
			favoriteLoading.current = true;
		} else {
			favoriteLoading.current = true;
		}
	};

	const handleFavorite = (e) => {
		e.stopPropagation();
		if (cUser?.id) {
			if (favoriteLoading.current) {
				if (isLike) {
					deleteFavorite();
				} else {
					addFavorite();
				}
			}
		} else {
			toastAlert("로그인 후 이용 가능합니다.");
		}
	};

	const addFavorite = async () => {
		if (!isLike) {
			const param = {
				user_id: cUser?.id,
				target_type: "community",
				target_id: item?.id,
				influencer_id: reduxChannel?.user_id,
			};
			const res = await partnersApi.addFavoriteHistory(param);
			if (res.code === 200) {
				getCommunityItemDetail();
			}
		}
	};

	const deleteFavorite = async () => {
		if (isLike) {
			const param = {
				userId: cUser?.id,
				targetType: "community",
				targetId: item?.id,
				influencer_id: reduxChannel?.user_id,
			};
			const res = await partnersApi.deleteFavoriteHistory(param);
			if (res.code === 200) {
				getCommunityItemDetail();
			}
		}
	};

	return (
		<>
			{type === "header" ? (
				<div
					className={`community-favorite-comment-div`}
					style={{
						gap: "6px",
						marginTop: "-1em",
						flexWrap: "wrap",
						rowGap: 0,
					}}
				>
					{/*<div style={{width: "100%", display: "flex", gap: "5px", alignItems: "center"}}>*/}
					<img
						// src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}.${reduxChannel?.profile_img_type}`}
						src={
							serviceType &&
							(serviceType === "longlife" || serviceType === "healthMagazine")
								? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${
										serviceType === "healthMagazine" &&
										!Object.prototype.hasOwnProperty.call(item, "content_type")
											? item?.longlife_id
											: item?.created_by
								  }${item?.profile_url ? `-${item?.profile_url}` : ""}.${
										item?.profile_img_type
								  }`
								: `${process.env.REACT_APP_S3_HOST}/image/together/profile_${item?.created_by}.${item?.profile_img_type}`
						}
						// src={`/assets/images/channel/doctor.png`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							// currentTarget.style.display = "none";
							currentTarget.src = `/assets/images/channel/basic.png`;
						}}
						alt={`채널 이미지`}
						style={{
							borderRadius: "50%",
							width: "auto",
							height: "1.2em",
						}}
					/>
					<p
						className={`gray`}
						style={{ cursor: "auto", fontWeight: "600", color: "#212529" }}
					>
						{serviceType &&
						(serviceType === "longlife" || serviceType === "healthMagazine")
							? item?.name
							: item?.created_by_name ?? reduxChannel?.nickname}
					</p>
					{/*</div>*/}
					<p className={`gray`} style={{ cursor: "auto" }}>
						·
					</p>
					<p className={`gray`} style={{ cursor: "auto" }}>
						{moment(item?.created_at).format("M월 D일")}
					</p>
					{item?.content_type !== 0 && (
						<>
							<p className={`gray`} style={{ cursor: "auto" }}>
								·
							</p>
							<p className={`gray`} style={{ cursor: "auto" }}>
								<img
									src={`/assets/images/channel/views.png`}
									alt={`커뮤니티 아이콘`}
								/>
								{serviceType && serviceType === "longlife"
									? item?.view_num ?? 0
									: serviceType && serviceType === "healthMagazine"
									? item?.content_type === 0
										? item?.view_num ?? 0
										: item?.clicked ?? 0
									: Math.ceil(item?.view_num * (5 + (item?.id % 10) / 10))}
								{/*{item?.view_num ?? 0}*/}
							</p>
						</>
					)}
				</div>
			) : (
				<div className={`community-favorite-comment-div`}>
					{serviceType &&
					serviceType === "healthMagazine" &&
					item?.content_type === 0 ? (
						<></>
					) : (
						<p
							className={`gray`}
							onClick={(e) => {
								if (
									serviceType &&
									(serviceType === "longlife" ||
										serviceType === "healthMagazine")
								) {
									console.log("longlife");
								} else {
									handleFavorite(e);
								}
							}}
						>
							<img
								src={`/assets/images/channel/favorite${
									isLike ? "-on" : "-off"
								}.png`}
								alt={`커뮤니티 아이콘`}
							/>{" "}
							{serviceType && serviceType === "healthMagazine"
								? item?.favorite_cnt ?? 0
								: itemNums?.like}
						</p>
					)}
					{serviceType && serviceType === "healthMagazine" ? (
						item?.content_type !== 0 && (
							<p className={`gray`}>
								<img
									src={`/assets/images/channel/comment.png`}
									alt={`커뮤니티 아이콘`}
								/>{" "}
								{serviceType && serviceType === "healthMagazine"
									? item?.comment_num ?? 0
									: itemNums?.comment}
							</p>
						)
					) : (
						<p className={`gray`}>
							<img
								src={`/assets/images/channel/comment.png`}
								alt={`커뮤니티 아이콘`}
							/>{" "}
							{itemNums?.comment}
						</p>
					)}
					{item?.content_type !== 0 && (
						<>
							<p
								className={`gray`}
								style={
									!type
										? {
												marginLeft: "auto",
										  }
										: {}
								}
							>
								<img
									src={`/assets/images/channel/views.png`}
									alt={`커뮤니티 아이콘`}
								/>
								{/*{item?.view_num}*/}
								{serviceType && serviceType === "longlife"
									? item?.view_num ?? 0
									: serviceType && serviceType === "healthMagazine"
									? item?.content_type === 0
										? item?.view_num ?? 0
										: item?.clicked ?? 0
									: Math.ceil(itemNums?.view * (5 + (item?.id % 10) / 10))}
							</p>
						</>
					)}
				</div>
			)}

			{type === "example" && (
				<div
					className={`community-favorite-comment-board-div ${
						item?.commentList?.length ? "" : "no-length"
					}`}
				>
					<div
						className={`community-example-detail-div`}
						onClick={handleFavorite}
						style={{ cursor: "pointer" }}
					>
						<img
							src={`/assets/images/channel/favorite${
								isLike ? "-on" : "-off"
							}.png`}
							alt={`커뮤니티 아이콘`}
							className={`favorite`}
						/>
						<p className={`example-detail-font`}>좋아요</p>
					</div>
					<div
						className={`community-example-detail-div`}
						onClick={handleCommentMove}
					>
						<img
							src={`/assets/images/channel/comment.png`}
							alt={`커뮤니티 아이콘`}
							className={`favorite`}
						/>
						<p className={`example-detail-font`}>댓글쓰기</p>
					</div>
				</div>
			)}
		</>
	);
};
export default CommunityFavorite;
